var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3125 43.0312H8.5C7.021 43.0312 5.84375 41.769 5.84375 40.2432V11.8214C5.84375 10.2935 7.021 9.03125 8.5 9.03125H42.5C43.979 9.03125 45.1563 10.2935 45.1563 11.8214V25.5C45.1563 26.3797 45.8703 27.0937 46.75 27.0937C47.6298 27.0937 48.3438 26.3797 48.3438 25.5V11.8214C48.3438 8.5085 45.713 5.84375 42.5 5.84375H8.5C5.287 5.84375 2.65625 8.5085 2.65625 11.8214V40.2432C2.65625 43.554 5.287 46.2187 8.5 46.2187H22.3125C23.1923 46.2187 23.9063 45.5047 23.9063 44.625C23.9063 43.7452 23.1923 43.0312 22.3125 43.0312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0938 4.25V10.625C10.0938 11.5048 10.8077 12.2188 11.6875 12.2188C12.5673 12.2188 13.2812 11.5048 13.2812 10.625V4.25C13.2812 3.37025 12.5673 2.65625 11.6875 2.65625C10.8077 2.65625 10.0938 3.37025 10.0938 4.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7188 4.25V10.625C37.7188 11.5048 38.4327 12.2188 39.3125 12.2188C40.1923 12.2188 40.9062 11.5048 40.9062 10.625V4.25C40.9062 3.37025 40.1923 2.65625 39.3125 2.65625C38.4327 2.65625 37.7188 3.37025 37.7188 4.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9062 4.25V10.625C23.9062 11.5048 24.6202 12.2188 25.5 12.2188C26.3798 12.2188 27.0938 11.5048 27.0938 10.625V4.25C27.0938 3.37025 26.3798 2.65625 25.5 2.65625C24.6202 2.65625 23.9062 3.37025 23.9062 4.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 20.7188H46.75C47.6298 20.7188 48.3438 20.0048 48.3438 19.125C48.3438 18.2452 47.6298 17.5312 46.75 17.5312H4.25C3.37025 17.5312 2.65625 18.2452 2.65625 19.125C2.65625 20.0048 3.37025 20.7188 4.25 20.7188Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6562 24.9688C30.2047 24.9688 24.9688 30.2047 24.9688 36.6562C24.9688 43.1077 30.2047 48.3437 36.6562 48.3437C43.1077 48.3437 48.3437 43.1077 48.3437 36.6562C48.3437 30.2047 43.1077 24.9688 36.6562 24.9688ZM36.6562 28.1562C41.3482 28.1562 45.1562 31.9642 45.1562 36.6562C45.1562 41.3482 41.3482 45.1562 36.6562 45.1562C31.9642 45.1562 28.1562 41.3482 28.1562 36.6562C28.1562 31.9642 31.9642 28.1562 36.6562 28.1562Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0625 31.875V36.125C35.0625 36.4969 35.1942 36.8581 35.4322 37.145L38.0885 40.3325C38.6516 41.0082 39.6567 41.0996 40.3325 40.5365C41.0082 39.9734 41.0996 38.9683 40.5365 38.2925L38.25 35.547V31.875C38.25 30.9952 37.536 30.2812 36.6562 30.2812C35.7765 30.2812 35.0625 30.9952 35.0625 31.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d3c0688e7335a667317f7ba0c64f8619.svg";
export { ForwardRef as ReactComponent };